<h4>Bitte konkretisieren Sie hier die Arbeitsschritte für die ausgewählte Komponente {{ editSpecificationsForm.get('technical_drawing')?.value }}. Die Spezifikation steht im Bezug zur gewählten Baugruppe.</h4>

<form clrForm [formGroup]="editSpecificationsForm">
  <table class="table" id="positionsTable">
    <thead>
    <tr>
      <th class="left">Zeichnungsnummer</th>
      <th class="left">Bezeichnung</th>
      <th class="left">Material</th>
      <th class="left">Kurzbeschreibung</th>
      <th></th>
    </tr>
    </thead>
    <tbody>
    <tr>
      <td class="left">{{ editSpecificationsForm.get('technical_drawing')?.value }}</td>
      <td class="left">{{ editSpecificationsForm.get('name')?.value }}</td>
      <td class="left">{{ editSpecificationsForm.get('material')?.value }}</td>
      <td class="left">{{ editSpecificationsForm.get('description')?.value }}</td>
      <td></td>
    </tr>
    <tr>
      <td></td>
      <td colspan="2" class="left">
        <div class="clr-form-control">
          <label for="specification" class="clr-control-label">SPEZIFIKATION</label>
          <div class="clr-control-container">
            <div class="clr-textarea-wrapper">
              <textarea formControlName="specification" id="specification" [placeholder]="editSpecificationsForm.get('specification')?.value" cols="70" rows="10" class="clr-textarea"></textarea>
              <cds-icon class="clr-validate-icon" shape="exclamation-circle"></cds-icon>
            </div>
            <span class="clr-subtext">Bitte erfassen Sie hier Details zur Verwendung dieses Bauteils/Verfahrens.</span>
          </div>
        </div>
      </td>
      <td>
        <clr-input-container *ngIf="!technology">
          <label>Stückzahl</label>
          <input clrInput type="number" formControlName="number_of_subparts" name="number_of_subparts" required />
          <clr-control-error>Bitte eine Nummer eintragen!</clr-control-error>
        </clr-input-container>
      </td>
    </tr>
    </tbody>
  </table>
</form>


<pre *ngIf="devMode" class="datepicker-output">
    {{ editSpecificationsForm.value | json }}
</pre>
